import { configureStore } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react'
import { routerMiddleware } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { createStateSyncMiddleware, initMessageListener } from 'redux-state-sync'
import thunk from 'redux-thunk'
import config from 'services/config'

import rootReducer from '../reducers/index'
import { googleAnalytics } from './middlewares/reactGAMiddlewares'

export const history = createBrowserHistory()

const stateSyncConfig = {
  channel: config.apiUrl,
  blacklist: [
    'signIn/saveGeoLocation',
    'signIn/beginLogin/pending',
    'signIn/beginLogin/fulfilled',
    'signIn/getQR/fulfilled',
    'TRYING_TO_LOG_IN',
    'signIn/saveGeoLocation',
    'signIn/getQR/fulfilled',
    'USER_LOGGED_IN',
    'CLEAR_HEADER_TITLES',
    'UPDATE_HEADER_TITLES',
    '@@router/LOCATION_CHANGE',
    'WS_CONNECTED'
  ]
}

const middleware = [
  thunk,
  routerMiddleware(history),
  googleAnalytics,
  createStateSyncMiddleware(stateSyncConfig)
]

const store = configureStore({
  reducer: rootReducer(history),
  middleware,
  enhancers: [
    Sentry.createReduxEnhancer({
      configureScopeWithState: (scope, state) => {
        // Set tag if the user is using imperial units.
        const currentHotelId = state.login.currentHotelId

        if (currentHotelId) {
          scope.setTag('user.subsidiaryId', currentHotelId)
        }

        const currentHotelName = state.login.currentHotel

        if (currentHotelName) {
          scope.setTag('user.subsidiary', currentHotelName)
        }

        const userName = state?.login?.currentUser?.name

        if (userName) {
          scope.setTag('user.name', userName)
        }
      }
    })
  ]
})

initMessageListener(store)

export default store
